import { useContext, useEffect, useState } from "react";
import CalculatorInputsToFill from "../../../components/CalculatorInputsToFill";
import api from "../../../services/api";
import ImportCosts from "../../../components/ImportCosts";
import { DollarContext } from "../../../contexts/DollarContext";

function CalculatorPage() {
  const dollarPriceToday = useContext(DollarContext);
  const dollarInFloat = parseFloat(
    dollarPriceToday?.replace("R$", "")?.replace(",", ".")
  );
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [containers, setContainers] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [selectedContainer, setSelectedContainer] = useState({});
  const [ii, setIi] = useState(0);
  const [pis, setPis] = useState(0);
  const [cofins, setCofins] = useState(0);
  const [ipi, setIpi] = useState(0);
  const [icms, setIcms] = useState(0);
  const [afrmmTax, setAfrmmTax] = useState({});
  const [freightCollectTax, setFreightCollectTax] = useState({});
  const [otherShippingCostsTax, setOtherShippingCostsTax] = useState({});
  const [customsClearenceTax, setCustomsClearenceTax] = useState({});
  const [otherExpensesTax, setOtherExpensesTax] = useState({});
  const [storageTax, setStorageTax] = useState({});
  const [productQuantityInContainer, setProductQuantityInContainer] =
    useState(0);

  const [dollarPrice, setDollarPrice] = useState(dollarInFloat);
  const [chinaPrice, setChinaPrice] = useState(0);
  const [targetPrice, setTargetPrice] = useState(0);
  const [landFreightPrice, setLandFreightPrice] = useState(0);
  const [portFreightPrice, setPortFreightPrice] = useState(0);
  const [previsions, setPrevisions] = useState([]);
  const [selectedPrevision, setSelectedPrevision] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const [productsResponse, containersResponse, previsionsResponse] =
          await Promise.all([
            api.get("/products"),
            api.get("/containers"),
            api.get("/previsions"),
          ]);

        if (productsResponse?.data) setProducts(productsResponse.data);
        if (containersResponse?.data) setContainers(containersResponse.data);
        if (previsionsResponse?.data) setPrevisions(previsionsResponse.data);

        console.log("prevision response: ", previsionsResponse.data);
      } catch (error) {
        console.error("Erro ao obter dados: ", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setDollarPrice(dollarInFloat);
  }, [dollarInFloat]);

  useEffect(() => {
    setProductQuantityInContainer(
      selectedContainer.sizeInCm / selectedProduct.size || ""
    );
  }, [selectedProduct, selectedContainer]);

  if (isLoading) return <p>Carregando....</p>;

  const handleProductSelectChange = (e) => {
    const product = products.find(
      (item) => Number(item.id) === Number(e.target.value)
    );

    if (!product) return;

    setSelectedProduct(product);

    setIi(product.ii);
    setPis(product.pis);
    setCofins(product.cofins);
    setIpi(product.ipi);
    setIcms(product.icms);
  };

  const handleContainerSelectChange = (e) => {
    const container = containers.find(
      (item) => Number(item.id) === Number(e.target.value)
    );

    if (!container) return;

    setSelectedContainer(container);
  };
  const handlePrevisionSelectChange = (e) => {
    const prevision = previsions.find(
      (item) => Number(item.id) === Number(e.target.value)
    );

    if (!prevision) return;

    setAfrmmTax({
      value: prevision.afrmm_tax,
      type: prevision.afrmm_tax_type,
    });
    setFreightCollectTax({
      value: prevision.freight_collect_tax,
      type: prevision.freight_collect_tax_type,
    });
    setOtherShippingCostsTax({
      value: prevision.other_shipping_costs_tax,
      type: prevision.other_shipping_costs_tax_type,
    });
    setCustomsClearenceTax({
      value: prevision.customs_clearance,
      type: prevision.customs_clearance_type,
    });
    setOtherExpensesTax({
      value: prevision.other_expenses_tax,
      type: prevision.other_expenses_type,
    });
    setStorageTax({
      value: prevision.storage_tax,
      type: prevision.storage_tax_type,
    });

    setSelectedPrevision(prevision);
  };

  return (
    <section className="min-h-screen flex  mt-10 items-center justify-center gap-10">
      <CalculatorInputsToFill
        handleProductSelectChange={handleProductSelectChange}
        handlePrevisionSelectChange={handlePrevisionSelectChange}
        previsions={previsions}
        handleContainerSelectChange={handleContainerSelectChange}
        products={products}
        containers={containers}
        dollarPrice={dollarPrice}
        setDollarPrice={setDollarPrice}
        chinaPrice={chinaPrice}
        setChinaPrice={setChinaPrice}
        targetPrice={targetPrice}
        setTargetPrice={setTargetPrice}
      />
      <ImportCosts
        productQuantityInContainer={productQuantityInContainer}
        ii={ii}
        pis={pis}
        icms={icms}
        cofins={cofins}
        ipi={ipi}
        afrmmTax={afrmmTax}
        freightCollectTax={freightCollectTax}
        otherExpensesTax={otherExpensesTax}
        customsClearenceTax={customsClearenceTax}
        otherShippingTax={otherShippingCostsTax}
        storageTax={storageTax}
        portFreightPrice={portFreightPrice}
        setPortFreightPrice={setPortFreightPrice}
        landFreightPrice={landFreightPrice}
        setLandFreightPrice={setLandFreightPrice}
        targetPrice={targetPrice}
        dollarPrice={dollarPrice}
        chinaPrice={chinaPrice}
      />
    </section>
  );
}
export default CalculatorPage;
